import { render, staticRenderFns } from "./GMBCompetitorDashboard.vue?vue&type=template&id=c256e37a&scoped=true"
import script from "./GMBCompetitorDashboard.vue?vue&type=script&lang=js"
export * from "./GMBCompetitorDashboard.vue?vue&type=script&lang=js"
import style0 from "./GMBCompetitorDashboard.vue?vue&type=style&index=0&id=c256e37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c256e37a",
  null
  
)

export default component.exports